import ReminderSettings from "./ReminderSettings";
export default ReminderSettings;